export const REPLACEMENT_DOG_STRING = "Reserve";



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/consts.js